<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="关键字" clearable>
            <el-button slot="append" icon="el-icon-search" @click="onSearch()" />
          </el-input>
        </el-form-item>
      </el-form>
      <el-button type="danger" size="small" plain @click="onCreate">重新生成</el-button>
    </div>
    <!--表格-->
    <el-table :data="datalist" height="100%">
      <el-table-column prop="Method" label="方式" min-width="50" />
      <el-table-column prop="Url" label="接口" min-width="240" />
      <el-table-column label="名称" min-width="120">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.Name" v-if="scope.row.edit" />
          <span v-else>{{ scope.row.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" min-width="150">
        <template slot-scope="{ row }">
          <el-input size="small" v-model="row.Remarks" v-if="row.edit" />
          <span v-else>{{ row.Remarks }}</span>
        </template>
      </el-table-column>
      <el-table-column label="启用" align="center" min-width="60">
        <template slot-scope="{ row }">
          <el-checkbox v-if="row.edit" v-model="row.State" />
          <i v-else-if="row.State" class="el-icon-check" />
        </template>
      </el-table-column>
      <el-table-column label="身份验证" align="center" min-width="60">
        <template slot-scope="{ row }">
          <el-checkbox v-if="row.edit" v-model="row.Identity" />
          <i v-else-if="row.Identity" class="el-icon-check" />
        </template>
      </el-table-column>
      <el-table-column label="授权验证" align="center" min-width="60">
        <template slot-scope="{ row }">
          <el-checkbox v-if="row.edit" v-model="row.Authorize" />
          <i v-else-if="row.Authorize" class="el-icon-check" />
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" min-width="80">
        <template slot-scope="{ row }">
          <el-link v-if="row.edit" type="success" icon="el-icon-upload" @click="saveRow(row)">保存</el-link>
          <el-link v-else type="primary" icon="el-icon-edit" @click="row.edit = !row.edit">编辑</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="total" @current-change="onSearch" />
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      datalist: [],
      total: 0,
      queryParams: {
        index: 1,
        size: 20,
      },
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.system.action.getList(this.queryParams).then((res) => {
        this.total = res.TotalCount
        this.datalist = res.Items.map((row) => {
          this.$set(row, 'edit', false)
          return row
        })
      }).catch(e => {
        console.log(e)
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //保存
    saveRow (row) {
      row.edit = false
      this.$apis.system.action.update(row).then(() => {
        this.$message({ message: '数据提交成功！', type: 'success' })
      })
    },
    //更新
    onCreate () {
      this.$confirm('此操作将根据系统反射生成数据, 是否继续?', '更新提示', {
        center: true,
      }).then(() => {
        const loading = this.$loading()
        this.$apis.system.action.create().then(() => {
          this.loadData()
        }).catch((e) => {
          this.$message.error(e)
        }).finally(() => {
          loading.close()
        })
      })
    }
  },
}
</script>
